import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import ChatSingleMessageClient from './ChatSingleMessageClient';

class DisplayMessages extends React.Component {
  static propTypes = {
    messages: PropTypes.array.isRequired,
    clientData: PropTypes.object.isRequired,
    trainerData: PropTypes.object.isRequired,
  };

  componentDidMount() {
    this.scrollToBottom();
    setTimeout(() => {
      this.scrollToBottom();
      // Don't judge meeeeeeeeeeeeeee. This waits so that the images can render and height can be calculated properly.
    }, 2000);
  }

  componentDidUpdate(nextProps) {
    if (nextProps.messages.length !== this.props.messages.length) {
      this.scrollToBottom();
    }
  }

  scrollToBottom = () => {
    if (this.messagesEnd) {
      this.messagesEnd.scrollIntoView({ behavior: 'instant' });
    }
  };

  displayAllMessages = () =>
    // const messagesLength = this.props.messages.length;
    // We want the FIRST message in any series to include the senders name.
    this.props.messages.map((message, index, messages) => {
      // Check if the sender of this message matches the sender of the previous message. If not, don't show the message header
      let showName = true;
      if (typeof messages[index - 1] !== 'undefined') {
        if (message.aspNetUserId === messages[index - 1].aspNetUserId) {
          showName = false;
        }
      }
      return (
        <ChatSingleMessageClient
          key={message.id}
          message={message}
          clientData={this.props.clientData}
          trainerData={this.props.trainerData}
          showName={showName}
        />
      );
    });

  render() {
    return (
      <div className="chat-messages-wrapper bg-light d-flex flex-column flex-1">
        <Helmet>
          <title>Chat</title>
        </Helmet>
        {this.displayAllMessages()}
        <div
          className="bottom-baseline-element"
          ref={(el) => {
            this.messagesEnd = el;
          }}
        />
      </div>
    );
  }
}

export default DisplayMessages;
